declare let window: Window & {
  requestGameWebToken?: () => void;
  onGameWebTokenReceive?: (gameWebToken: string) => void;
};

type OnGameWebTokenReceive = (gwt: string) => void;

let callbacks: OnGameWebTokenReceive[] = [];

export function requestGameWebToken(timeout = 10000): Promise<string | undefined> {
  if (!window.requestGameWebToken) {
    return Promise.resolve(undefined);
  }
  const timeoutRejection = new Promise<string | undefined>((_, reject) =>
    setTimeout(() => reject('timeout'), timeout)
  );

  const p = new Promise<string | undefined>(resolve => {
    callbacks.push(gameWebToken => {
      resolve(gameWebToken);
    });
  });

  if (!window.onGameWebTokenReceive) {
    window.onGameWebTokenReceive = gwt => {
      window.onGameWebTokenReceive = undefined;
      callbacks.forEach(callback => callback(gwt));
      callbacks = [];
    };
    window.requestGameWebToken();
  }

  return Promise.race([p, timeoutRejection]);
}
